/* file description */
export const reverseArr = (arr = [], n = 10) => {
  const len = arr.length;
  const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
  const res = [];
  for (let i = 0; i < lineNum; i++) {
    // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
    const temp = arr.slice(i * n, i * n + n);
    res.push(temp);
  }
  return res;
};
